import HeaderLogo from 'components/Header/HeaderLogo'
import { StyledLanguageWrapper, StyledLoginHeader } from './styles'

function LoginHeader() {
  return (
    <StyledLoginHeader shouldHaveBg>
      <HeaderLogo />
      <StyledLanguageWrapper>
        {/* Uncomment when it will be needed (approx 3.1) CENTRAL-1289 */}
        {/* <LanguageSelector /> */}
      </StyledLanguageWrapper>
    </StyledLoginHeader>
  )
}

export default LoginHeader
